import { keyframes, css } from "@emotion/react";
import colors from "assets/css/colors";

const shineKeyFrames = keyframes`
  to {
    background-position: 100% 0, /* move highlight to right */ 0 0;
  }
`;

export default css`
  width: 100%;
  height: 100%;
  background: linear-gradient(
        to right,
        rgba(255, 255, 255, 0),
        rgba(255, 255, 255, 0.5) 50%,
        rgba(255, 255, 255, 0) 80%
      )
      repeat-y 0 0 / 50px 500px,
    ${colors.bgGrey};
  animation: ${shineKeyFrames} 2s infinite;
`;
